import React, { useEffect, useState, useRef } from "react";
import GridTable from "../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import SettingTable from "../../incidents/incidentList/SettingTable";
import { TableLoader } from "../../../library/common/Loader";
import {
  HBNEXT_ORG_ID,
  OBSERVATION_ITEM_TYPE,
  ORG_ID,
  GRID_DEFAULT_PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SEFETY_HBN_CLIENT_SYSTEM_PRI,
  SW_HBN_CLIENT_PARTNER_PRI,
} from "../../../constant/constant";
import AddIcon from "@mui/icons-material/Add";
import NORow from "../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../admin/shared/ReportRowManipulate";
import Buttons from "../../../library/custom/button/Button";
import { checkPrivileges, hasAllPrivileges } from "../../../utils/rolesHelper";
import FilterList from "../../case/shared/FilterCaseList";
import FilterButton from "../../../library/custom/filterButton/filterButton";
import { getFormatedDate, InactiveClient } from "../../../utils/helper";
import { useDebounce } from "../../../utils/useDebounceSearch";
import downloadIcon from "../../../assets/downloadIcon.svg";
import DialogBox from "../../../library/common/DialogBox";
import { useSelector } from "react-redux";
import { getPreviousRoute } from "../../../utils/routeTracker";
import {
  VIEW_OBSERVATION_DETAILS,
  OBSERVATION,
  VIEW_OBSERVATION_LISTS,
} from "../../../constant/routeContant";

const allowedRoutePrefixes = [
  VIEW_OBSERVATION_LISTS,
  VIEW_OBSERVATION_DETAILS,
  OBSERVATION,
];

const ObservationList = ({
  observationList,
  getObservationListData,
  isLoading,
  handleViewOnClick,
  addObservation,
  handleDeleteOnClick,
}) => {
  const { filterObj } = useSelector((state) => state.observationList);
  const [filterObjRestored, setFilterObjRestored] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const isFirstRender = useRef(true);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(0);
  const [status, setStatus] = useState("");
  const [itemTypesId, setItemTypesId] = useState("");
  const [dateOfCaseFrom, setdateOfCaseFrom] = useState("");
  const [dateOfCaseTo, setdateOfCaseTo] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [observationId, setObservationId] = useState();
  const [observationFilterData, setObservationFilterData] = useState({
    searchText: "",
    page: 1,
    pageSize: GRID_DEFAULT_PAGE_SIZE,
    fromdate: "",
    todate: "",
    location: "",
    Status: "",
    itemTypes: "",
    isSendMail: false,
  });

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [isTableLoading, setisTableLoading] = useState(false);
  const isShowClient = checkPrivileges([12]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const dateOfCaseHandlerFrom = (e) => {
    setdateOfCaseFrom(e);
  };

  const dateOfCaseHandlerTO = (e) => {
    setdateOfCaseTo(e);
  };

  const columns = [
    { field: "insObservationId", headerName: "ID", flex: 1 },
    { field: "observationDate", headerName: "Date of Entry", flex: 1.5 },
    { field: "location", headerName: "Location/Jobsite", flex: 1.5 },
    { field: "observedTypeValue", headerName: "Item Type", flex: 1.5 },
    { field: "observedByName", headerName: "Added by", flex: 1.5 },
    { field: "statusText", headerName: "Status", flex: 1 },

    {
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            viewOnClick={(row) =>
              handleViewOnClick(
                row?.insObservationId,
                row?.observedType,
                row?.observedEmployee,
                row?.status,
              )
            }
            view={checkPrivileges([12, 84, 85, 86])}
            viewLabel="View Observation"
            deleted={
              isShowClient ||
              hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI) ||
              hasAllPrivileges(SEFETY_HBN_CLIENT_SYSTEM_PRI)
            }
            deleteLabel={"Delete Observation"}
            deleteOnClick={(row) => deleteObservationHandle(row)}
          />
        );
      },
    },
  ];

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    const data = {
      ...observationFilterData,
      searchText: observationFilterData.searchText ?? "",
      page: 1,
      pageSize: newPazeSize,
      isSendMail: false,
    };
    setObservationFilterData(data);
    getObservationListData(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    getObservationListData({
      ...observationFilterData,
      page: newPage + 1,
      pageSize: pageSize,
    });
  };

  const handleautoSearch = (event) => {
    setPage(0);
    setSearch(event.target.value);
  };

  const onRowClick = (rows) => {
    if (rows.value) {
      const { row } = rows;
      handleViewOnClick(
        row?.insObservationId,
        row?.observedType,
        row?.observedEmployee,
        row?.status,
      );
    }
  };
  const onStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleApply = () => {
    setAnchorEl(null);
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    const data = {
      searchText: search,
      page: 1,
      pageSize: pageSize,
      location: "",
      Status: status ? status : "",
      fromdate: (dateOfCaseFrom && getFormatedDate(dateOfCaseFrom)) ?? "",
      todate: (dateOfCaseTo && getFormatedDate(dateOfCaseTo)) ?? "",
      itemTypes: itemTypesId ? itemTypesId : "",
      isSendMail: false,
    };
    setObservationFilterData(data);
    getObservationListData(data);
  };

  const handleClear = () => {
    setItemTypesId("");
    setAnchorEl(null);
    setStatus("");
    setdateOfCaseFrom("");
    setdateOfCaseTo("");
    setPage(0);
    setPageSize(GRID_DEFAULT_PAGE_SIZE);
    setSearch("");
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    const data = {
      // searchText: search,
      searchText: "",
      page: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      location: "",
      Status: "",
      itemTypes: "",
      isSendMail: false,
    };
    setObservationFilterData(data);
    getObservationListData(data);
  };

  const typeOnItemTypeChanges = (e) => {
    setItemTypesId(e?.target?.value);
  };

  const sendEmail = () => {
    const data = {
      searchText: search,
      page: 1,
      pageSize: pageSize,
      location: "",
      Status: status ? status : "",
      fromdate: (dateOfCaseFrom && getFormatedDate(dateOfCaseFrom)) ?? "",
      todate: (dateOfCaseTo && getFormatedDate(dateOfCaseTo)) ?? "",
      itemTypes: itemTypesId ? itemTypesId : "",
      isSendMail: true,
    };
    setObservationFilterData(data);
    getObservationListData(data);
  };
  const deleteObservationHandle = (row) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setObservationId(row?.insObservationId);
  };
  const deletehandle = () => {
    setOpenModal(false);
    const data = {
      observationId: observationId,
    };
    handleDeleteOnClick(data);
  };

  useEffect(() => {
    const previousRoute = getPreviousRoute();
    const isFromPreserveRoute =
      previousRoute &&
      allowedRoutePrefixes.some((prefix) => previousRoute.startsWith(prefix)) &&
      sessionStorage.getItem("observationListPreserveState") === "true";
    sessionStorage.removeItem("observationListPreserveState");

    if (isFromPreserveRoute && filterObj) {
      const {
        searchText = "",
        Status = "",
        itemTypes = "",
        fromdate = "",
        todate = "",
        page: savedPage = 1,
        pageSize: savedPageSize = GRID_DEFAULT_PAGE_SIZE,
      } = filterObj;
      setSearch(searchText);
      setStatus(Status);
      setItemTypesId(itemTypes);
      setdateOfCaseFrom(String(fromdate));
      setdateOfCaseTo(String(todate));
      setPage(savedPage > 0 ? savedPage - 1 : 0);
      setPageSize(savedPageSize);
      setObservationFilterData({
        searchText,
        Status,
        itemTypes,
        fromdate,
        todate,
        page: savedPage,
        pageSize: savedPageSize,
        location: "",
        isSendMail: false,
      });
    } else {
      setSearch("");
      setStatus("");
      setItemTypesId("");
      setdateOfCaseFrom("");
      setdateOfCaseTo("");
      setPage(0);
      setPageSize(GRID_DEFAULT_PAGE_SIZE);
      setObservationFilterData({
        searchText: "",
        page: 1,
        pageSize: GRID_DEFAULT_PAGE_SIZE,
        fromdate: "",
        todate: "",
        location: "",
        Status: "",
        itemTypes: "",
        isSendMail: false,
      });
    }
    setFilterObjRestored(true);
  }, []);

  useEffect(() => {
    if (!filterObjRestored) return;
    const data = {
      searchText: debouncedSearch,
      page: page + 1,
      pageSize: pageSize,
      fromdate: (dateOfCaseFrom && getFormatedDate(dateOfCaseFrom)) ?? "",
      todate: (dateOfCaseTo && getFormatedDate(dateOfCaseTo)) ?? "",
      location: "",
      Status: status ? status : "",
      itemTypes: itemTypesId ? itemTypesId : "",
      isSendMail: false,
    };
    setObservationFilterData(data);
    getObservationListData(data);
  }, [debouncedSearch, page, pageSize, filterObjRestored]);

  useEffect(() => {
    if (!filterObjRestored) return;
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
  }, [debouncedSearch]);
  return (
    <>
      {openModal && (
        <DialogBox
          open={openModal}
          rows={[]}
          header={"Confirm Deletion"}
          deletehandle={deletehandle}
          handleCloseModal={() => setOpenModal(false)}
          view
        />
      )}

      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Observations</div>
          <div>
            {checkPrivileges([12, 84, 85]) && (
              <Buttons
                varientContained={true}
                label={" + Add Observation"}
                startIcon={<AddIcon />}
                onClick={() => addObservation()}
              />
            )}
          </div>
        </div>
        <div className="grid_main_body">
          <div className="div-filter-container">
            <div className="filter_of_caselist">
              <div className="searchcaseid">
                <label htmlFor="search">
                  <span>
                    <SearchIcon />
                  </span>
                  <div>
                    <input
                      id="search"
                      placeholder="Search"
                      type="text"
                      value={search}
                      className=""
                      onChange={handleautoSearch}
                      autoComplete="off"
                      data-testid="search-input"
                    />
                  </div>
                </label>
              </div>
              <div className="filterbtn">
                <FilterButton
                  label={"Filters"}
                  handleClick={(e) => handleClick(e)}
                />
                <FilterList
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                  resetFilter={handleClear}
                  handleSearch={handleApply}
                  status={status}
                  observationStatus={true}
                  onStatusChange={onStatusChange}
                  itemTypes={true}
                  itemTypesId={itemTypesId}
                  typeOnItemTypeChanges={typeOnItemTypeChanges}
                  dateFilter={true}
                  listTypeValues={OBSERVATION_ITEM_TYPE}
                  dateOfCaseFrom={dateOfCaseFrom}
                  dateOfCaseHandlerFrom={dateOfCaseHandlerFrom}
                  dateOfCaseTo={dateOfCaseTo}
                  dateOfCaseHandlerTO={dateOfCaseHandlerTO}
                />
              </div>
            </div>
            <div className="div-download-email-right" onClick={sendEmail}>
              <span>
                <img
                  src={downloadIcon}
                  className="DownLoadLogo"
                  alt="DownLoad Logo"
                />
              </span>
              Download Data
            </div>
          </div>
          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              {isTableLoading ? (
                ""
              ) : (
                <GridTable
                  getRowId={(r) => r.insObservationId}
                  rows={observationList?.observationData ?? []}
                  rowCount={observationList?.noOfRecords ?? 0}
                  onClick={(rows) => onRowClick(rows)}
                  columns={columns}
                  loading={isLoading}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ObservationList;
